var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCompletedIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM14.2318 8.35984C14.5853 7.93556 15.2159 7.87824 15.6402 8.2318C16.0644 8.58537 16.1218 9.21593 15.7682 9.64021L10.7682 15.6402C10.5883 15.856 10.326 15.9863 10.0453 15.999C9.76462 16.0117 9.49154 15.9058 9.29287 15.7071L7.29287 13.7071C6.90234 13.3166 6.90234 12.6834 7.29287 12.2929C7.68339 11.9024 8.31656 11.9024 8.70708 12.2929L9.93278 13.5186L14.2318 8.35984Z",
    fill: "#5FC287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCompletedIcn);
export default __webpack_public_path__ + "static/media/status-completed-icn.b35980f6b0b85aac555cb37cf8a1a541.svg";
export { ForwardRef as ReactComponent };